<template>
  <v-btn
    v-bind="{
      color: 'white',
      height: 40,
      rounded: true,
      theme: 'dark',
      variant: 'outlined',
      ...$props,
      ...$attrs,
    }"
  >
    <slot />
  </v-btn>
</template>
<script>
export default {
  name: 'DpplSignupLogoutButton',
};
</script>
<style scoped>
.v-btn.v-size--default {
  font-size: 16px;
}
</style>
